import { hydrateRoot } from 'react-dom/client';
import { type FC } from 'react';
import { RelayEnvironmentProvider, useLazyLoadQuery } from 'react-relay';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import serverVars from 'server-vars';
import * as tracking from 'dibs-tracking';
import { ServerVarsContextProvider } from '../sharedComponents/ServerVarsContext';
import { QuestionListLayout } from '../questionsAnswers/questionList/questionListLayout';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { questionListRootQuery } from '../questionsAnswers/questionListRootQuery';
import { type questionListRootQuery as questionListRootQueryType } from '../questionsAnswers/__generated__/questionListRootQuery.graphql';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
const { page = 1 } = serverVars.get('relayVariables');

const ComponentWrapper: FC = () => {
    const data = useLazyLoadQuery<questionListRootQueryType>(
        questionListRootQuery,
        serverVars.get('relayVariables'),
        {
            fetchPolicy: 'store-only',
        }
    );

    return <QuestionListLayout viewer={data.viewer} page={page} />;
};

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <IntlProvider locale={serverVars.get('locale')} disableTranslations>
            <ServerVarsContextProvider
                isMobile={serverVars.get('settings.isMobile')}
                isTablet={serverVars.get('settings.isTablet')}
                isDesktop={serverVars.get('settings.isDesktop')}
            >
                <RelayEnvironmentProvider environment={environment}>
                    <ComponentWrapper />
                </RelayEnvironmentProvider>
            </ServerVarsContextProvider>
        </IntlProvider>
    );
    tracking.trackPageview();
});
